import React from 'react';
import PropTypes from 'prop-types';
import ImatgesComponent from '../../CustomInstallacio/ImatgesComponent';

/*
# En tu configuración de campo
{
		"name": "photos",
		"type": "gallery-massive-actions",
		"label": "Galería de imágenes",
		"options": {
				"endpoint": "/api/photos/",
				"reorder_endpoint": "/api/photos/reorder/",  # Opcional, por defecto "/photos/reorder/"
				"params": {"project_id": "project"},
				"params_upload": {"project_id": "project"}
		}
}

El endpoint /api/photos/reorder/ recibirá un POST con:
{
    "images": [
        {"id": 1, "position": 1},
        {"id": 3, "position": 2},
        {"id": 2, "position": 3}
    ]
}
*/
const TypeGalleryMassive = (props) => {
	const { 
		editable = true, 
		isEditing = true, 
		options: inputConfig, 
		isCreating, 
		upload_param_name, 
		label,
		sortable = true, // Por defecto activado para gallery-massive-actions
		reorderEndpoint
	} = props;
	if (isCreating) return null;
	return (
		<ImatgesComponent
			{...props}
			postParams={inputConfig.params_upload}
			getParams={inputConfig.params}
			endpoint={inputConfig.endpoint}
			disabled={!editable || !isEditing}
			name={upload_param_name}
			title={label}
			withMultiselect
			sortable={sortable && editable && isEditing}
			reorderEndpoint={reorderEndpoint || inputConfig.reorder_endpoint || "/photos/reorder/"}
		/>
	);
};

TypeGalleryMassive.propTypes = {
	editable: PropTypes.bool,
	isEditing: PropTypes.bool,
	options: PropTypes.object,
	isCreating: PropTypes.bool
};

export default TypeGalleryMassive;
